import axios from "_u/axios"



// 会员等级列表查看
export const mInfoGradeList = body => {
    return axios.post("api/wx/usersetting/list", body)
}

// 会员等级列表修改
export const mInfoGradeUpdate = body => {
    return axios.post("api/wx/usersetting/saveSetting", body)
}

// 会员列表查看
export const mInfoList = body => {
    return axios.post("api/wx/userinfo/list", body)
}

// 查看明细
export const mInfoView = id => {
    return axios.post("api/wx/userinfo/view", { id })
}

// 积分明细列表
export const mInfoIntegralList = body => {
    return axios.post("api/wx/userintegral/list", body)
}



// 保存充值规则 body-> list
export const mInfoRuleSave = body => {
    return axios.post("api/recharge/setting/saveSetting", body)
}

// 充值规则列表 body-> list
export const mInfoRuleList = () => {
    return axios.post("api/recharge/setting/list")
}

// 充值记录列表
export const mInfoRechargeList = body => {
    return axios.post("api/recharge/record/list",body)
}

// 可选会员列表
export const chooseMemberList = () => {
    return axios.post("api/wx/userinfo/chooseList")
}

// 充值记录详情
export const mInfoRechargeView = id => {
    return axios.post("api/recharge/record/view",{id})
}	
